import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type PortfolioConfigKey =
    | 'portfolioOverview'
    | 'phasePerformance'
    | 'phasePerformanceManage'
    | 'phasePerformanceManageAddTemplate'
    | 'phasePerformanceManageMapProject';

export const portfolioConfig: Record<PortfolioConfigKey, MenuConfigItem> = {
    portfolioOverview: {
        name: 'Portfolio Overview',
        link: 'portfolio-overview',
        title: 'Portfolio Overview',
        tooltip: 'Portfolio Overview',
    },

    phasePerformance: {
        name: 'Phase Performance',
        link: 'phase-performance',
        title: 'Phase Performance Review',
        tooltip: 'Phase Performance',
    },
    phasePerformanceManage: {
        name: '',
        link: 'manage',
        title: 'Manage Phase Templates',
    },
    phasePerformanceManageAddTemplate: {
        name: '',
        link: 'add-template',
        title: 'Configure Phase Template',
    },
    phasePerformanceManageMapProject: {
        name: '',
        link: 'map-project',
        title: 'Map Project To Template For Complex Projects',
    },
};
